import React from 'react'
import VisDiv from './frontend_components/VisDiv'

/**
 * A component that renders a bottom mobile menu with two tabs: "REGISTRO" and "FOGLIO DI LAVORO".
 * The "REGISTRO" tab is highlighted if the `isWorksheet` prop is false.
 * The "FOGLIO DI LAVORO" tab is highlighted if the `isWorksheet` prop is true.
 * When a tab is clicked, the corresponding `clickRegister` or `clickWorksheet` prop is called.
 * #unused
 * @param {function} clickRegister - The function to be called when the "REGISTRO" tab is clicked.
 * @param {function} clickWorksheet - The function to be called when the "FOGLIO DI LAVORO" tab is clicked.
 * @param {boolean} isWorksheet - Whether the "FOGLIO DI LAVORO" tab should be highlighted.
 */
const BottomMobileMenu = ({clickRegister, clickWorksheet, isWorksheet}) => {

  const color = {backgroundColor:"red", color: 'white'}
  return (
        <div  className='bottom-menu'>
            <VisDiv className='tab' onClick={clickRegister} style={{backgroundColor: !isWorksheet && "#00127b", color: !isWorksheet && 'white'}}>
                REGISTRO
            </VisDiv>
            <VisDiv className='tab' onClick={clickWorksheet} style={{backgroundColor: isWorksheet && "#00127b", color: isWorksheet && 'white'}}>
                FOGLIO DI LAVORO
            </VisDiv>
        </div>
  )
}

export default BottomMobileMenu
